import { inject, Injectable } from '@angular/core';
import { CreateScreeningService } from '@/app/pages/screening-brief-create/services/create-screening/create-screening.service';
import { evaluateScreeningBrief, ScreeningPreflightResult } from '../screening-brief.utils';

/**
 * The brief's pre-flight check.
 *
 * Today it runs the heuristic locally. This class is the seam: when the server-side validation
 * endpoint exists, only `run()` changes — the overlay already renders `{ pass, reasons }`.
 */
@Injectable({ providedIn: 'root' })
export class ScreeningPreflightService {

  private readonly createScreeningService = inject(CreateScreeningService);

  run(): ScreeningPreflightResult {
    return evaluateScreeningBrief({
      lookFor: this.createScreeningService.lookFor(),
      restrictions: this.createScreeningService.restrictions(),
      reportType: this.createScreeningService.reportType(),
      reportPrompt: this.createScreeningService.reportPrompt(),
    });
  }
}
